export default __webpack_public_path__ + "static/media/modal-flower.0da5f1a8.webp";